var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { SubGroupConfiguration } from "../../../../data";
import { TooltipApi } from "sb-resp-ui";
var GroupingDropdown = /** @class */ (function (_super) {
    __extends(GroupingDropdown, _super);
    function GroupingDropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.filterBox = React.createRef();
        _this.wrap = React.createRef();
        _this.setTooltipMsg = TooltipApi.getInstance().setMessage.bind(_this);
        return _this;
    }
    GroupingDropdown.prototype.handleClick = function (event) {
        if (this.filterBox.current) {
            this.filterBox.current.classList.add("isHidden");
        }
    };
    GroupingDropdown.prototype.componentDidMount = function () {
        window.addEventListener("click", this.handleClick.bind(this));
    };
    GroupingDropdown.prototype.componentWillUnmount = function () {
        window.removeEventListener("click", this.handleClick);
    };
    /* istanbul ignore next */
    GroupingDropdown.prototype.toggleOptions = function () {
        this.wrap.current && this.wrap.current.classList.toggle("rj-ev-list__gr-dropdown--active");
        this.filterBox.current && this.filterBox.current.classList.toggle("isHidden");
    };
    GroupingDropdown.prototype.selectOption = function (ev, newOption) {
        this.toggleOptions();
        this.props.handler(newOption);
    };
    GroupingDropdown.prototype.renderDesktopDropdown = function () {
        var _this = this;
        var tooltip = this.setTooltipMsg("" + this.props.dict.SortBy);
        return (React.createElement("div", { id: "rj-ev-list__gr-dropdown__wrap", className: "rj-ev-list__gr-dropdown__wrap", "data-uat": "div-ev-list-gr-dropdown-wrap", ref: this.wrap },
            React.createElement("label", __assign({ className: "rj-ev-list__gr-dropdown__label", onClick: function (ev) { ev && ev.stopPropagation(); _this.toggleOptions(); }, "data-uat": "label-ev-list-gr-dropdown-label" }, tooltip),
                React.createElement("span", { className: "icon i-o-ev-filter i-14" })),
            React.createElement("div", { className: "rj-ev-list__gr-dropdown__options-holder isHidden", "data-uat": "div-ev-list-gr-dropdown-options-holder", ref: this.filterBox },
                React.createElement("div", { className: "rj-ev-list__gr-dropdown__option rj-ev-list__gr-dropdown__option-league", onClick: function (ev) { ev && ev.stopPropagation(); _this.selectOption(ev, SubGroupConfiguration.League); }, "data-uat": "div-ev-list-gr-dropdown-option-league" }, this.props.dict.SortBy + " " + this.props.dict.League),
                React.createElement("div", { className: "rj-ev-list__gr-dropdown__option rj-ev-list__gr-dropdown__option-time", onClick: function (ev) { ev && ev.stopPropagation(); _this.selectOption(ev, SubGroupConfiguration.Time); }, "data-uat": "div-ev-list-gr-dropdown-option-time" }, this.props.dict.SortBy + " " + this.props.dict.Time))));
    };
    GroupingDropdown.prototype.renderMobileDropdown = function () {
        var _this = this;
        return (React.createElement("div", { className: "rj-ev-list__gr-dropdown__wrap", "data-uat": "div-ev-list-gr-dropdown-wrap" },
            React.createElement("label", { className: "rj-ev-list__gr-dropdown__label", "data-uat": "label-ev-list-gr-dropdown-label" },
                React.createElement("span", { className: "icon i-o-ev-filter i-14" })),
            React.createElement("select", { className: "rj-ev-list__gr-dropdown__select", onChange: function (ev) { ev && ev.stopPropagation(); _this.selectOption(ev, ev.target.value); }, defaultValue: this.props.subGroupBy, "data-uat": "select-ev-list-gr-dropdown-select" },
                React.createElement("option", { className: "rj-ev-list__gr-dropdown__select-option", "data-uat": "option-ev-list-gr-dropdown-select-option-league", value: SubGroupConfiguration.League }, this.props.dict.SortBy + " " + this.props.dict.League),
                React.createElement("option", { className: "rj-ev-list__gr-dropdown__select-option", "data-uat": "option-ev-list-gr-dropdown-select-option-time", value: SubGroupConfiguration.Time }, this.props.dict.SortBy + " " + this.props.dict.Time))));
    };
    GroupingDropdown.prototype.render = function () {
        return (this.props.isDesktop
            ? this.renderDesktopDropdown()
            : this.renderMobileDropdown());
    };
    return GroupingDropdown;
}(React.PureComponent));
export { GroupingDropdown };
//# sourceMappingURL=GroupingDropdown.js.map